import React from 'react';
import PropTypes from 'prop-types';
import styles from './ErrorLayout.scss';

const ErrorLayout = ({ routes, children }) => (
  <div className={styles.ErrorLayout}>
    <div className={styles.main}>
      {React.cloneElement(children, { code: routes[routes.length - 1].code })}
    </div>
  </div>
);

ErrorLayout.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
  })).isRequired,
  children: PropTypes.node.isRequired,
};

export default ErrorLayout;
